import PersonIcon from "@material-ui/icons/Person";

export const UserIcon = PersonIcon;
export { UserEdit } from "./edit";
export { UserList } from "./list";
